<div class="company-api-user-container container default-padding mat-elevation-z1" fxLayout="column" fxLayoutGap="15px">
  <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'API_USER.TITLE' | translate }}</h2>
  <hr/>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <span *ngIf="company?.apiUserProfileUuid; else notCreated">{{ 'API_USER.READY' | translate }}</span>
    <ng-template #notCreated>
      <div fxLayout="column" fxLayoutGap="15px">
        <div style="max-width: 420px">{{ 'API_USER.NOT_CREATED' | translate }}</div>
        <button mat-raised-button class="default-button" (click)="createApiUser()">
          {{ 'API_USER.CREATE_BUTTON' | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
